module.exports = require("./fr-MC");